<section class="mt-3 container">
    <h1>{{"AUTO_DRAW.TITLE" | translate}}</h1>
    <!-- 參數list -->
    <mat-accordion>
        <ng-container *ngFor="let param of params; let timIdx=index">
            <mat-expansion-panel expanded>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <span>{{ "AUTO_DRAW.ENUM.TIM_KEY.NUMBER" | translate }}：</span>
                        <span>{{param.number}}</span>
                        
                    </mat-panel-title>
                    <mat-panel-description>
                        <!-- {{param.tim_type}} -->
                    </mat-panel-description>
                </mat-expansion-panel-header>
                <div class="panel-body">
                    <!-- 基本參數 -->
                    <div class="mb-4">
                        <h5 class="form-title mb-3">
                            {{"AUTO_DRAW.QUOTE.BASIC" | translate}}
                        </h5>
                        <div class="row">
                            <!-- TIM編號 -->
                            <div class="col-12 col-md-4 col-lg-3 pe-md-0 mb-3 px-4">
                                 <label class="d-flex mb-1">{{ "AUTO_DRAW.ENUM.TIM_KEY.NUMBER" | translate }}</label>
                                <input 
                                    type="text" 
                                    class="form-control" 
                                    [placeholder]="'PLACEHOLDER.TEXT' | translate"
                                    [(ngModel)]="param.number"
                                    disabled
                                >
                            </div>
                            <!-- TIM分類 -->
                            <div class="col-12 col-md-4 col-lg-3 pe-md-0 mb-3 px-4">
                                 <label class="d-flex mb-1">
                                    {{ "AUTO_DRAW.ENUM.TIM_KEY.TIM_TYPE" | translate }}
                                    <span class="text-danger">*</span>
                                </label>
                                <mat-select 
                                    class="form-control" 
                                    [(ngModel)]="param.tim_type"
                                    (ngModelChange)="syncParam(param, 'TIM_TYPE')"
                                >
                                    <ng-container *ngFor="let optionCode of sortEnumObj(TIM_TYPE)">
                                        <!-- 目前只有導熱硅膠片、導熱硅脂 -->
                                        <mat-option
                                            *ngIf="optionCode === TIM_TYPE['TIM'] || optionCode === TIM_TYPE['TMP']"
                                            [value]="optionCode"
                                        >
                                            {{ "AUTO_DRAW.ENUM.TIM_TYPE." + optionCode | translate }}
                                        </mat-option>
                                    </ng-container>
                                </mat-select>
                            </div>
                            <!-- 型號 -->
                            <div class="col-12 col-md-4 col-lg-3 pe-md-0 mb-3 px-4">
                                 <label class="d-flex mb-1">{{ "AUTO_DRAW.ENUM.TIM_KEY.TIM_MODEL" | translate }}</label>
                                <mat-select
                                    class="form-control"
                                    [(ngModel)]="param.tim_model"
                                    (ngModelChange)="syncParam(param, 'PRODUCT_NUMBER')"
                                >
                                    <mat-option [value]="null">-</mat-option>
                                    <ng-container *ngFor="let item of modelOptions | keyvalue" [ngSwitch]="param.tim_type">
                                        <ng-container *ngSwitchCase="item.key">
                                            <ng-container *ngFor="let product of modelOptions[item.key]">
                                                <mat-option *ngIf="product.product_number !== 'APD1200'" [value]="product.product_number">
                                                    {{product.product_number}}
                                                </mat-option>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                </mat-select>
                            </div>
                        </div>
                    </div>
                    <!-- 規格參數 -->
                    <div class="mb-4">
                        <h5 class="form-title mb-3">
                            {{"AUTO_DRAW.QUOTE.SPEC" | translate}}
                        </h5>
                        <div class="row" *ngIf="param.tim_type !== TIM_TYPE['TMP']">
                            <!-- 長 -->
                            <div class="col-12 col-md-4 col-lg-3 mb-3 px-4">
                                <label class="d-flex mb-1">
                                    <p class="mb-0 me-2">
                                        <span>{{ "AUTO_DRAW.ENUM.TIM_KEY.LENGTH" | translate }}</span>
                                        <span>(d1)</span>
                                        <span class="text-danger">*</span>
                                    </p>
                                    <p
                                        class="comment-icon m-0"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="right"
                                        data-bs-html="true"
                                        [title]="
                                            'AUTO_DRAW.QUOTE.MEMO.LENGTH' | translate: {
                                                'memoImg': memoImg
                                            }
                                        "
                                    >?</p>
                                </label>
                                <div class="row">
                                    <div class="col-10">
                                        <input 
                                            type="number" 
                                            min="0"
                                            class="form-control" 
                                            [placeholder]="'PLACEHOLDER.NUMBER' | translate"
                                            [(ngModel)]="param.length"
                                            (ngModelChange)="syncParam(param, 'LENGTH', timIdx)"
                                        >
                                    </div>
                                    <p class="col-2 p-0 m-0 mt-auto">mm</p>
                                </div>
                            </div>
                            <!-- 寬 -->
                            <div class="col-12 col-md-4 col-lg-3 mb-3 px-4">
                                <label class="d-flex mb-1">
                                    <p class="mb-0 me-2">
                                        <span>{{ "AUTO_DRAW.ENUM.TIM_KEY.WIDTH" | translate }}</span>
                                        <span>(d2)</span>
                                        <span class="text-danger">*</span>
                                    </p>
                                    <p
                                        class="comment-icon m-0"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="right"
                                        data-bs-html="true"
                                        [title]="
                                            'AUTO_DRAW.QUOTE.MEMO.WIDTH' | translate: {
                                                'memoImg': memoImg
                                            }
                                        "
                                    >?</p>
                                </label>
                                <div class="row">
                                    <div class="col-10">
                                        <input 
                                            type="number"
                                            min="0"
                                            class="form-control" 
                                            [placeholder]="'PLACEHOLDER.NUMBER' | translate"
                                            [(ngModel)]="param.width"
                                            (ngModelChange)="syncParam(param, 'WIDTH', timIdx)"
                                        >
                                    </div>
                                    <p class="col-2 p-0 m-0 mt-auto">mm</p>
                                </div>
                            </div>
                            <!-- 厚 -->
                            <div class="col-12 col-md-4 col-lg-3 mb-3 px-4">
                                <label class="d-flex mb-1">
                                    {{ "AUTO_DRAW.ENUM.TIM_KEY.THICKNESS" | translate }}
                                    <span class="text-danger">*</span>
                                </label>
                                <div class="row">
                                    <div class="col-10">
                                        <input 
                                            type="number"
                                            min="0" 
                                            class="form-control me-1" 
                                            [placeholder]="'PLACEHOLDER.NUMBER' | translate"
                                            [(ngModel)]="param.thickness"
                                            (ngModelChange)="syncParam(param, 'THICKNESS', timIdx)"
                                        >
                                    </div>
                                    <p class="col-2 p-0 m-0 mt-auto">mm</p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <!-- 導熱係數 -->
                            <div class="col-12 col-md-4 col-lg-3 pe-md-0 mb-3 px-4">
                                <label class="d-flex mb-1">
                                    {{ "AUTO_DRAW.ENUM.TIM_KEY.THERMAL_COEFFICIENT" | translate }}
                                    <span class="text-danger">*</span>
                                </label>
                                <mat-select
                                    class="form-control"
                                    [(ngModel)]="param.thermal_coefficient"
                                    (ngModelChange)="syncParam(param, 'THERMAL_COEFFICIENT')"
                                >
                                    <ng-container *ngFor="let item of wmkOptions | keyvalue" [ngSwitch]="param.tim_type">
                                        <ng-container *ngSwitchCase="item.key">
                                            <ng-container *ngFor="let wmk of wmkOptions[item.key]">
                                                <mat-option [value]="wmk">{{wmk}}</mat-option>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                </mat-select>
                            </div>
                            <!-- 硬度計 -->
                            <div
                                *ngIf="param.tim_type !== TIM_TYPE['TMP']"
                                class="col-12 col-md-4 col-lg-3 pe-md-0 mb-3 px-4"
                            >
                                <label class="d-flex mb-1">
                                    <span>{{ "AUTO_DRAW.ENUM.TIM_KEY.HARDNESS_TESTER" | translate }}</span>
                                    <span class="text-danger">*</span>
                                </label>
                                <mat-select
                                    class="form-control"
                                    [(ngModel)]="param.hardness_tester"
                                    (ngModelChange)="syncParam(param, 'HARDNESS_TESTER')"
                                >
                                    <mat-option *ngFor="let optionCode of sortEnumObj(HARDNESS_TESTER)" [value]="optionCode">
                                        {{"AUTO_DRAW.ENUM.HARDNESS_TESTER." + optionCode | translate}}
                                    </mat-option>
                                </mat-select>
                            </div>
                            <!-- 硬度 -->
                            <div
                                *ngIf="param.tim_type !== TIM_TYPE['TMP']"
                                class="col-12 col-md-4 col-lg-3 pe-md-0 mb-3 px-4"
                            >
                                 <label class="d-flex mb-1">
                                    <span>{{ "AUTO_DRAW.ENUM.TIM_KEY.HARDNESS" | translate }}</span>
                                    <span class="text-danger">*</span>
                                </label>
                                <div class="d-flex align-items-center">
                                    <input 
                                        type="number"
                                        min="0"
                                        class="form-control me-1" 
                                        [placeholder]="'PLACEHOLDER.NUMBER' | translate"
                                        [(ngModel)]="param.hardness"
                                        (ngModelChange)="syncParam(param, 'HARDNESS')"
                                    >
                                    <p class="me-1 mb-0">±</p>
                                    <input 
                                        disabled
                                        type="number" 
                                        class="form-control" 
                                        [placeholder]="'PLACEHOLDER.TOLERANCE' | translate"
                                        [(ngModel)]="param.hardness_tolerance"
                                        (ngModelChange)="syncParam(param, 'HARDNESS_TOLERANCE')"
                                    >
                                </div>
                            </div>
                            <!-- 總需求量 -->
                            <div
                                *ngIf="param.tim_type === TIM_TYPE['TMP']"
                                class="col-12 col-md-4 col-lg-3 pe-md-0 mb-3 px-4"
                            >
                                 <label class="d-flex mb-1">
                                    {{ "AUTO_DRAW.ENUM.TIM_KEY.ORDER_QUANTITY" | translate }}
                                    <span class="text-danger">*</span>
                                </label>
                                <div class="row">
                                    <div class="col-10">
                                        <input 
                                            type="number"
                                            min="0"
                                            class="form-control mr-1" 
                                            [placeholder]="'PLACEHOLDER.NUMBER' | translate"
                                            [(ngModel)]="param.order_quantity"
                                        >
                                    </div>
                                    <span class="col-2 p-0 m-0 mt-auto">kg</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <!-- 背膠 -->
                            <div
                                *ngIf="param.tim_type !== TIM_TYPE['TMP']"
                                class="col-12 col-md-4 col-lg-3 pe-md-0 mb-3 px-4"
                            >
                                <label class="mb-1">{{ "AUTO_DRAW.ENUM.TIM_KEY.ADHESIVE" | translate }}</label>
                                <div class="d-flex align-items-center">
                                    <mat-select
                                        class="form-control me-1"
                                        [(ngModel)]="param.adhesive"
                                        (ngModelChange)="syncParam(param, 'ADHESIVE')"
                                    >
                                        <mat-option *ngFor="let optionCode of sortEnumObj(ADHESIVE)" [value]="optionCode">
                                            {{"AUTO_DRAW.ENUM.ADHESIVE." + optionCode | translate}}
                                        </mat-option>
                                    </mat-select>
                                    <mat-select
                                        [disabled]="param.adhesive === ADHESIVE.NULL"
                                        class="form-control"
                                        [(ngModel)]="param.adhesive_type"
                                        (ngModelChange)="syncParam(param, 'ADHESIVE_TYPE')"
                                    >
                                        <!-- <mat-option [value]="null">-</mat-option> -->
                                        <ng-container *ngFor="let adhesive of ADHESIVE_MODEL">
                                            <mat-option 
                                                [value]="adhesive.model"
                                                [disabled]="param.adhesive === ADHESIVE.NULL"
                                            >
                                                {{ adhesive.model }}
                                            </mat-option>
                                        </ng-container>
                                    </mat-select>
                                </div>
                            </div>
                            <!-- 是否含膠厚 -->
                            <div 
                                *ngIf="param.tim_type !== TIM_TYPE['TMP']"
                                class="col-12 col-md-4 col-lg-3 pe-md-0 mb-3 px-4"
                            >
                                <label class="mb-1">{{ "AUTO_DRAW.ENUM.TIM_KEY.ADHESIVE_INCLUDE_THICKNESS" | translate }}</label>
                                <mat-select
                                    [disabled]="param.adhesive === ADHESIVE.NULL"
                                    class="form-control"
                                    [(ngModel)]="param.adhesive_include_thickness"
                                >
                                    <mat-option *ngFor="let optionCode of sortEnumObj(INCLUDE_THICKNESS)" [value]="optionCode">
                                        {{"AUTO_DRAW.ENUM.BOOLEAN." + optionCode | translate}}
                                    </mat-option>
                                </mat-select>
                            </div>
                            <!-- 膠厚度 -->
                            <div
                                *ngIf="param.tim_type !== TIM_TYPE['TMP']"
                                class="col-12 col-md-4 col-lg-3 pe-md-0 mb-3 px-4"
                            >
                                <label class="mb-1">{{ "AUTO_DRAW.ENUM.TIM_KEY.ADHESIVE_THICKNESS" | translate }}</label>
                                <div class="d-flex align-items-end">
                                    <input 
                                        [disabled]="param.adhesive === ADHESIVE.NULL || true"
                                        type="number"
                                        min="0"
                                        class="form-control mr-1" 
                                        [placeholder]="'PLACEHOLDER.NUMBER' | translate"
                                        [(ngModel)]="param.adhesive_thickness"
                                    >
                                    <p class="m-0">mm</p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <!-- 顏色 -->
                            <div
                                *ngIf="param.tim_type !== TIM_TYPE['TMP']"
                                class="col-12 col-md-4 col-lg-3 pe-md-0 mb-3 px-4"
                            >
                                 <label class="d-flex mb-1">{{ "AUTO_DRAW.ENUM.TIM_KEY.COLOR" | translate }}</label>
                                <div class="d-flex align-items-end">
                                    <input 
                                    type="text" 
                                    class="form-control" 
                                    [placeholder]="'PLACEHOLDER.TEXT' | translate"
                                    [(ngModel)]="param.color">
                                </div>
                            </div>
                            <!-- 形狀 -->
                            <div
                                *ngIf="param.tim_type !== TIM_TYPE['TMP']"
                                class="col-12 col-md-4 col-lg-3 pe-md-0 mb-3 px-4"
                            >
                                 <label class="d-flex mb-1">{{ "AUTO_DRAW.ENUM.TIM_KEY.SHAPE" | translate }}</label>
                                <mat-select
                                    class="form-control"
                                    [(ngModel)]="param.shape"
                                    (ngModelChange)="syncParam(param, 'SHAPE')"
                                >
                                    <mat-option *ngFor="let optionCode of sortEnumObj(SHAPE)" [value]="optionCode">
                                        <span>{{"AUTO_DRAW.ENUM.SHAPE." + optionCode | translate}}</span>
                                        <span *ngIf="optionCode === SHAPE.irregilar">
                                            {{"AUTO_DRAW.ALERT.SHAPE" | translate}}
                                        </span>
                                    </mat-option>
                                </mat-select>
                            </div>
                            <!-- 手撕位 -->
                            <div
                                *ngIf="param.tim_type !== TIM_TYPE['TMP']"
                                class="col-12 col-md-4 col-lg-3 pe-md-0 mb-3 px-4"
                            >
                                 <label class="d-flex mb-1">
                                    <p class="m-0 me-2">
                                        <span>{{ "AUTO_DRAW.ENUM.TIM_KEY.PULLTAB" | translate }}</span>
                                        <span> x </span>
                                        <span>{{ "AUTO_DRAW.ENUM.TIM_KEY.WIDTH" | translate }}</span>
                                    </p>
                                    <p
                                        class="comment-icon m-0"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="right"
                                        data-bs-html="true"
                                        [title]="
                                            'AUTO_DRAW.QUOTE.MEMO.PULLTAB' | translate: {
                                                'memoImg': memoImg
                                            }
                                        "
                                    >?</p>
                                </label>
                                <div class="row">
                                    <mat-checkbox
                                        class="col-2"
                                        color="primary"
                                        [(ngModel)]="param.pulltab"
                                        (ngModelChange)="syncParam(param, 'PULLTAB')"
                                    ></mat-checkbox>
                                    <div class="col-9">
                                        <mat-select 
                                            class="form-control" 
                                            [(ngModel)]="param.pulltab_length"
                                            [disabled]="!param.pulltab || false"
                                        >
                                            <ng-container *ngIf="param.number">
                                                <mat-option *ngFor="let optionCode of pulltabLengthLists[param.number]" [value]="optionCode">
                                                    {{optionCode}} x {{param.width || 0}}
                                                </mat-option>
                                            </ng-container>
                                        </mat-select>
                                    </div>
                                    <p class="col-1 p-0 m-0 mt-auto">
                                        <span>mm</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 圖紙參數 -->
                    <div class="mb-4" *ngIf="param.tim_type !== TIM_TYPE['TMP']">
                        <h5 class="form-title mb-3">
                            {{"AUTO_DRAW.QUOTE.DRAW" | translate}}
                        </h5>
                        <div class="row">
                            <!-- 日期 -->
                            <div class="col-12 col-md-4 col-lg-2 pe-md-0 mb-3 px-4">
                                 <label class="d-flex mb-1">{{'AUTO_DRAW.ENUM.TIM_KEY.DATE' | translate}}</label>
                                <div class="datepicker">
                                    <input 
                                        class="input form-control text-center" 
                                        matInput 
                                        [(ngModel)]="param.date"
                                        [placeholder]="'PLACEHOLDER.DATE' | translate" 
                                        [matDatepicker]="pickerTimDate"
                                    >
                                    <mat-datepicker-toggle class="datepicker-toggle" [for]="pickerTimDate" matSuffix></mat-datepicker-toggle>
                                    <mat-datepicker #pickerTimDate disabled="false" touchUi="true"></mat-datepicker>
                                </div>
                            </div>
                            <!-- 檔名 -->
                            <div class="col-12 col-md-4 col-lg-2 pe-md-0 mb-3 px-4">
                                <label class="d-flex mb-1">
                                    <p class="m-0 mr-2">
                                        <span>{{ "AUTO_DRAW.ENUM.TIM_KEY.FILE_NAME" | translate }}</span>
                                    </p>
                                </label>
                                <div>
                                    <input 
                                        type="text" 
                                        class="form-control mr-1" 
                                        [placeholder]="'PLACEHOLDER.TEXT' | translate"
                                        [(ngModel)]="param.file_name"
                                    >
                                </div>
                            </div>
                            <!-- 圖號 -->
                            <div class="col-12 col-md-4 col-lg-2 pe-md-0 mb-3 px-4">
                                 <label class="d-flex mb-1">{{ "AUTO_DRAW.ENUM.TIM_KEY.DRAWING_NUMBER" | translate }}</label>
                                <div>
                                    <input 
                                    type="text" 
                                    class="form-control mr-1" 
                                    [placeholder]="'PLACEHOLDER.TEXT' | translate"
                                    [(ngModel)]="param.drawing_number"
                                    >
                                </div>
                            </div>
                            <!-- 單一工件中數量 -->
                            <div
                                *ngIf="param.tim_type !== TIM_TYPE['TMP']"
                                class="col-12 col-md-4 col-lg-3 pe-md-0 mb-3 px-4"
                            >
                                 <label class="d-flex mb-1">{{ "AUTO_DRAW.ENUM.TIM_KEY.QUANTITY" | translate }}</label>
                                <div class="row">
                                    <div class="col-10">
                                        <input 
                                            type="number"
                                            min="0"
                                            class="form-control" 
                                            [placeholder]="'PLACEHOLDER.NUMBER' | translate"
                                            [(ngModel)]="param.quantity"
                                        >
                                    </div>
                                    <p class="col-2 p-0 m-0 mt-auto">pcs</p>
                                </div>
                            </div>
                            <!-- 視角 -->
                            <div class="col-12 col-md-4 col-lg-3 pe-md-0 mb-3 px-4">
                                 <label class="d-flex mb-1">{{ "AUTO_DRAW.ENUM.TIM_KEY.VIEW_ANGLE" | translate }}</label>
                                <mat-select class="form-control" [(ngModel)]="param.view_angle">
                                    <mat-option *ngFor="let optionCode of sortEnumObj(VIEW_ANGLE)" [value]="optionCode">
                                        {{"AUTO_DRAW.ENUM.VIEW_ANGLE." + optionCode | translate}}
                                    </mat-option>
                                </mat-select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="panel-footer text-end">
                    <button 
                        mat-raised-button 
                        color="basic"
                        class="me-3"
                        (click)="setDefaultParam(param)"
                    >
                        {{"BUTTON.RESET" | translate}}
                    </button>
                    <button 
                        mat-raised-button 
                        color="warn"
                        [disabled]="params.length <= 1"
                        (click)="deleteParam(param)"
                    >
                        {{"BUTTON.DELETE" | translate}}
                    </button>
                </div>
            </mat-expansion-panel>
        </ng-container>
    </mat-accordion>
    <!-- 新增按鈕 -->
    <div class="mt-4 text-center">
        <button
            class="add-btn"
            mat-fab 
            (click)="addParam()"
            [disabled]="
                params.length >= 26 || 
                (params[params.length - 1] && params[params.length - 1].number === 'Z')
            "
        >
            <span class="add-icon">+</span>
        </button>
    </div>
    <!-- 送出 -->
    <div class="mt-4 text-center">
        <!--  -->
        <ng-container *ngIf="isAllTmpType(); else tmpOnly">
            <button 
                mat-raised-button 
                color="primary"
                (click)="submitParam(ALGO_TYPE.draw)"
            >
                {{"BUTTON.SUBMIT" | translate}}
            </button>
        </ng-container>
        <!-- 若都為導熱硅脂則為聯絡我們 -->
        <ng-template #tmpOnly>
            <button 
                mat-raised-button 
                color="primary"
                (click)="openContactModal()"
            >
                {{"BUTTON.CONTACT" | translate}}
            </button>
        </ng-template>
    </div>
</section>
<app-contact-us [project]="project" [needCreateProject]="true"></app-contact-us>